<template>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63.94 55.2"
         :style="`fill: ${iconColor};`"
         :width="width"
         :height="height">
        <path d="M69.5,52.8l-4.2-42a2.59,2.59,0,0,0-.9-1.7,3,3,0,0,0-1.8-.6L30.8,11.7,16.5,9a2.56,2.56,0,0,0-1.9.4,2.47,2.47,0,0,0-1,1.6l-8,41.4A2.56,2.56,0,0,0,6,54.3a2.47,2.47,0,0,0,1.6,1l15.2,2.9a3.11,3.11,0,0,0,.7.9,2.27,2.27,0,0,0,1.6.6h.2l3.2-.3,22.1,4.3H51a1.5,1.5,0,0,0,1.1-.4,2.22,2.22,0,0,0,.8-1.3l.9-5.2,13.4-1.3a2.59,2.59,0,0,0,1.7-.9A2.79,2.79,0,0,0,69.5,52.8ZM9.8,51.7l7.4-38.4,2,.2a2.35,2.35,0,0,0-.8,2.1L22.2,54Zm39.5,7.6-7-1.4,7.4-.7ZM26.4,55.6l-3.9-39,39-3.9,3.9,39Z"
              transform="translate(-5.56 -8.5)"/>
        <path d="M54.4,20.3,31.7,22.9a2,2,0,0,0-1.8,2.2,2,2,0,0,0,2,1.8h.2l22.7-2.6a2,2,0,1,0-.4-4Z"
              transform="translate(-5.56 -8.5)"/>
        <path d="M45.1,30.9,32.7,32.3a2,2,0,0,0-1.8,2.2,2,2,0,0,0,2,1.8h.2l12.4-1.4a2,2,0,1,0-.4-4Z"
              transform="translate(-5.56 -8.5)"/>
    </svg>
</template>

<script>
    export default {
        name: "NotesIcon",
        props: {
            width: {
                type: [Number, String],
                default: 18
            },
            height: {
                type: [Number, String],
                default: 18
            },
            iconColor: {
                type: String,
                default: '#211f20'
            }
        }
    }
</script>

<style scoped>

</style>
